module.exports = __webpack_public_path__ + "static/media/menu-icon-green.ccef8f25.png";